import React from 'react'
import Layout from '../components/layout-global'
import Home from '../components/home'

const IndexPage = () => (
  <Layout>
    <Home />
  </Layout>
)

export default IndexPage
